export const appConstants = {
  storage: {
    'USER': '   ',
    'USERNAME': '',
  },
  pattern: {
    'NAME': /^[a-zA-Z . \-\']*$/,
    'CITY': /^[a-zA-Z . \-\']*$/,
    'DECIMAL_VALID': '^[0-9]+([,.][0-9]+)?$'
  },
  defaultAwsPath: '',
  // manufacturingLocation: {
  //   'United States': '4',
  //   'M & CA': '6',
  //   'Asia': '3',
  //   'Canada': '5',
  //   'EMEA': '2',
  //   'USA & Canada': '7',
  // },
  paysForShippingCode: {
    'Manufacturer': 13,
    'Buyer': 1
  },
  NDAType: {
    'No NDA Needed': 'RFX_SECURITYTYPE_NO_SECURE',
    'Single Confirm': 'RFX_SECURITYTYPE_TOTALY_SECURE',
    'Double Confirm': 'RFX_SECURITYTYPE_TOTALY_SECURE_CONFIDENTIALITY_AGR'
  },
  RFQStatusKey: {
    'RFX_BUYERSTATUS_PENDING_RELEASE': 'RFX_BUYERSTATUS_PENDING_RELEASE'
  },

  settingDefault:{
  'decimalValueDefault':null
  },
  downloadCustomerCSVFile:{
    'downloadCustomerCSVFile': 'https://s3.us-east-2.amazonaws.com/mfg.mp2020/MyCustomers.csv'

    },
  blacklistedBookType: 'BOOK_BOOKTYPE_BLACKLISTED',
  hotlistedBookType : 'BOOK_BOOKTYPE_HOTLIST',
  AccountType:{
          Basic :'Basic',
          GrowthPackage : 'Growth Package',
          Gold :'Gold',
          Platinum :'Platinum',
          Starter:'Starter',
          Professional:'Professional',
          ProfessionalPlus:'Professional Plus',
          Registered:'Registered',
          Premium:'Premium'
      },
  UserLocation:{
    Asia :'Asia',
    Europe :'Europe',
    Mexico :'Mexico',
    US :'US',
    Canada :'Canada'
  },
  UserRole:{
    Supplier :'Supplier',
    Buyer : 'Buyer',
    Seller:'Seller'
  },
  Package:{
    Starter: 'Starter',
    GrowthPackage: 'GrowthPackage'
  },
  StripePriceNickname:{
    ProfessionalMonthly: 'Professional (M)',
    ProfessionalYearly: 'Professional (Y)',
    RFQUnlocksMonthly: '+3 RFQ Unlocks (M)',
    RFQUnlocksYearly: '+3 RFQ Unlocks Per Month',
    Registered: 'Registered'
  },
  PackageMode:{
    Annually: 'annually',
    Monthly: 'monthly'
  },
  RfqBuyerStatus:{
    Offline :20,
    AnotherMFG:16,
    AnotherNonMFG:17,
    Awarded:6
  },
  ForManufacturers:{
  POST_MANU:'Post Manufacturing Job'

  },
  MaterialRedirection:{
    MaterialUrl:'https://rawmats.mfg.com/auth/sso?token='
  }
};


export const qmsConstants = {
 isQMSTrailModelShown : false
}

/** Legacy key; cleared on buyer login to drop stale Quick Parts portal state. */
export const STORAGE_BUYER_PORTAL_VARIANT = "buyerPortalVariant";

